/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import { Grid, GridItem } from '@bwoty-web/ui-kit';
import { useGlobals } from '@bwoty-web/ui-kit/hooks';
import Disclaimer from './components/Disclaimer';
import Newsletter from './components/Newsletter';
import './footerGlobetrotter.scss';

const FooterGlobetrotter = () => {
  const { baseUrl, content } = useGlobals();
  const { headlines } = content;

  return (
    <div className="footer-globetrotter">
      <Grid root>
        <GridItem>
          <div className="footer-globetrotter-container">
            <a href="/" className="footer-globetrotter-logo">
              <img
                src={`${baseUrl}/static/images/logo-globetrotter-horizontal.svg`}
                alt="Globetrotter logotyp"
              />
            </a>
            <div className="footer-globetrotter-sections">
              {headlines?.length > 0 &&
                headlines.map((headline) => {
                  return (
                    <div key={headline.title}>
                      <ul className="footer-globetrotter-section__links">
                        {headline.links.map((link) => {
                          return (
                            <li
                              className="footer-globetrotter-section__link"
                              key={link.label}
                            >
                              <a href={link.href}>{link.label}</a>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  );
                })}
              <Newsletter />
            </div>
          </div>
          <Disclaimer
            links={content.disclaimer.links}
            copyright={content.disclaimer.copyright}
          />
        </GridItem>
      </Grid>
    </div>
  );
};

FooterGlobetrotter.propTypes = {
  content: PropTypes.shape({
    headlines: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        links: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    ),
    disclaimer: PropTypes.shape({
      copyright: PropTypes.string,
      links: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    paymentOptions: PropTypes.arrayOf(
      PropTypes.shape({
        image: PropTypes.shape({}),
        readMoreLink: PropTypes.object,
      }),
    ).isRequired,
    newsletter: PropTypes.shape({
      title: PropTypes.string,
      introText: PropTypes.string,
      emailPlaceholder: PropTypes.string,
      submitBtnText: PropTypes.string,
      successMessage: PropTypes.string,
      invalidMessage: PropTypes.string,
      socialMediaLinks: PropTypes.arrayOf(PropTypes.shape({})),
      appLink: PropTypes.shape({}),
    }),
  }).isRequired,
};

export default FooterGlobetrotter;
